import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Col, FormGroup, Row } from "reactstrap";

import { encryptStorage } from "../../constants/EncryptStorage";
import { LoadingSpinner } from "../../constants/const";
import { GetLanguageString } from "../helper/Components";
import { GetSelectedLanguage } from "../helper/Method";
import { ApiUnit } from "../unit/ApiUnit";

const SelectUnitForMember = ({
  setValues,
  values,
  setErrors,
  removeUnitId,
  unitId,
  check,
  page = "",
  edit = false,
}) => {
  let loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  // const [excludeExUnit, setExcludeExUnit] = useState(true);
  const [unitList, setUnitList] = useState([]);

  if (
    (unitTypeName === "Markaz" || unitTypeName === "Zone") &&
    page === "TransferHabib"
  )
    check = "TransferHabib";
  else if (page !== "") check = "";

  let unitType =
    check === "Outside"
      ? unitTypeName
      : check === "TransferHabib"
      ? "Halqa"
      : "null";
  if (unitId === 0 || (check === "Outside" && edit === false))
    unitId = loggedInUnitId;

  useEffect(() => {
    ApiUnit()
      .getUnitList(unitId, loggedInUnitId, false, unitType, true)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [unitId, loggedInUnitId, removeUnitId, unitType]);
  const handleChangeUnits = (record) => {
    if (record !== null) {
      if (unitType === "Tanzeem" && record.unitTypeName === "Halqa") {
        loggedInUnitId = record.value;
        unitType = "null";
      }
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitType, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setValues({
        ...values,
        unit: record,
      });
      setErrors({
        unitId: "",
      });
    }
  };
  return (
    <>
      {unitList.length !== 0 ? (
        <>
          <Row>
            {unitList.map((record, index) => {
              const unitOptions = [];
              record.unitList.forEach((d) =>
                d.unitTypeName !== "UsraMuavin" &&
                (check !== "Outside" || d.unitTypeName !== "Munfarid")
                  ? unitOptions.push({
                      value: d.id,
                      label: d.name,
                      unitTypeName: d.unitTypeName,
                    })
                  : null
              );
              let selected = {};
              if (record.selectedUnit !== null) {
                selected = {
                  value: record.selectedUnit.id,
                  label: record.selectedUnit.name,
                };
              }
              const isLastIndex = index === unitList.length - 1;

              return (
                <Col md="3" key={index}>
                  <FormGroup>
                    <Row>
                      <Col md="10">
                        <Select
                          options={unitOptions}
                          isDisabled={edit}
                          value={selected}
                          className="basic-single ur"
                          classNamePrefix="select"
                          onChange={handleChangeUnits}
                        />
                      </Col>
                      {isLastIndex ? null : (
                        <Col md="2" className="p-0">
                          {GetSelectedLanguage() === "en" ? (
                            <i className="fa fa-arrow-right fa-lg m"></i>
                          ) : (
                            <i className="fa fa-arrow-left fa-lg m"></i>
                          )}
                        </Col>
                      )}
                    </Row>
                  </FormGroup>
                </Col>
              );
            })}
            {edit ? (
              <h4
                className={
                  GetSelectedLanguage() === "en"
                    ? "message text-left"
                    : "message text-right"
                }
              >
                *{" "}
                <GetLanguageString props="move_member_note_cannot_change_unit_message_in_edit" />
              </h4>
            ) : null}
          </Row>
        </>
      ) : (
        LoadingSpinner()
      )}
    </>
  );
};

export default SelectUnitForMember;
